export const LocalStorageKeyConstants = {
  CURRENT_ROUTE: 'current_route',
  IS_PAGE_REFRESH: 'isPageRefresh',
  ANNOUNCEMENT_DISMISSED: 'announcementDismissed',
};
